import type { Day, Place } from "../puzzles/types";
import { journeyOrder } from "./route";

/**
 * The day's three routes for the score screen (DECISIONS 2026-10-03 "The map of your day"), each in time order:
 * Pin it its three steps (the answer and its trail), Next stop the whole journey, "Whose steps?" the whole life
 * (the reveal route when there is one, else the five places).
 */
export function dayRoutes(day: Day): { pin: Place[]; next: Place[]; who: Place[] } {
  const [pin, next, who] = day.rounds;
  return {
    pin: journeyOrder([pin.answer, ...(pin.trail ?? [])]).stops,
    next: [...next.route, next.answer],
    who: journeyOrder(who.reveal?.route?.length ? who.reveal.route : who.clues).stops,
  };
}
